/**
 * Local calendar-date formatting.
 *
 * Use these INSTEAD of `date.toISOString().slice(0, 10)` / `.substring(0, 10)`.
 * `toISOString()` converts to UTC first, so in UTC+ timezones (e.g. Dubai UTC+4,
 * CEST UTC+2) it shifts local midnight on the 1st back to the previous day —
 * which is why the "this month" filter resolved to June 30 instead of July 1,
 * and why "today" defaults can land on yesterday in the early morning.
 *
 * These read the date's LOCAL components, so they always reflect the calendar
 * date the user sees. NOT for visiera platform timestamps (those have their own
 * Dubai-time handling via parseDateUTC/toDbDate) — only for UI dates, filter
 * presets, and today/current-month defaults.
 */

/** A Date (or date-ish) → "YYYY-MM-DD" from local components. Defaults to now. */
export function toLocalYMD(d = new Date()) {
  const dt = d instanceof Date ? d : new Date(d);
  return [
    dt.getFullYear(),
    String(dt.getMonth() + 1).padStart(2, "0"),
    String(dt.getDate()).padStart(2, "0"),
  ].join("-");
}

/** A Date (or date-ish) → "YYYY-MM" from local components. Defaults to now. */
export function toLocalYM(d = new Date()) {
  const dt = d instanceof Date ? d : new Date(d);
  return [dt.getFullYear(), String(dt.getMonth() + 1).padStart(2, "0")].join("-");
}
